"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumLeadSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_1 = require("../base/meta-data");
exports.SourgumLeadSchema = {
    name: 'sourgum-lead',
    alias: 'Sourgum Lead',
    shortName: 'Lead',
    applications: ['aap'],
    returnType: {
        aap: transport_types_1.Customer.AllianceLeadTransport,
    },
    searchableAttributes: [
        {
            field: 'firstName',
            alias: 'First Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'lastName',
            alias: 'Last Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'email',
            alias: 'Email',
            shortName: 'Email',
            searchableByDefault: true,
        },
        {
            field: 'phoneNumber',
            alias: 'Phone Number',
            shortName: 'Phone',
            searchableByDefault: false,
        },
        {
            field: 'company',
            alias: 'Company Name',
            shortName: 'Company',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.addressLine1',
            alias: 'Address Line 1',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.addressLine2',
            alias: 'Address Line 2',
            shortName: 'Address Line 2',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.city',
            alias: 'Address City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.state',
            alias: 'Address State',
            shortName: 'State',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.zip',
            alias: 'Address Zip Code',
            shortName: 'Zip',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.county',
            alias: 'Address County',
            shortName: 'County',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            field: 'status',
            alias: 'Status',
            shortName: 'Lead Status',
            type: 'STRING',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: transport_types_1.Customer.LeadStatuses.map((status) => ({
                value: status,
                label: transport_types_1.Customer.LeadStatusLabels[status],
            })),
        },
        {
            field: 'type',
            alias: 'Lead Type',
            shortName: 'Type',
            type: 'STRING',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: transport_types_1.Customer.LeadTypes.map((type) => ({
                value: type,
                label: transport_types_1.Customer.LeadTypeLabels[type],
            })),
        },
        {
            field: 'customerType',
            alias: 'Customer Type',
            shortName: 'Customer Type',
            type: 'STRING',
            allowedOperators: 'ALL',
            options: transport_types_1.Customer.customerTypes.map((type) => ({
                value: type,
                label: transport_types_1.Customer.CustomerTypeLabels[type],
            })),
            allowsMultipleValues: true,
        },
        {
            field: 'contactEvents.date',
            alias: 'Contact Date',
            shortName: 'Date',
            type: 'TIMESTAMP',
            format: 'ISO',
            allowedOperators: 'ALL',
        },
        {
            field: 'requestedDeliveryDate',
            alias: 'Requested Delivery Date',
            shortName: 'Delivery Date',
            type: 'TIMESTAMP',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            field: 'requestedMaterial',
            alias: 'Requested Material',
            shortName: 'Material',
            type: 'STRING',
            allowedOperators: 'ALL',
            options: Object.keys(transport_types_1.Material).map((material) => ({
                value: material,
                label: transport_types_1.MaterialLabels[material],
            })),
            allowsMultipleValues: true,
        },
        ...meta_data_1.MetaDataFilters,
    ],
    extraMappings: [],
    dropFields: [
        {
            field: 'allianceCustomer',
        },
    ],
};
//# sourceMappingURL=sourgum-lead.js.map